export class DashboardSettingsDTO{
    clientId: string;
    urlServer :string;
    name :string;
    tab :string;
    userName :string;
    token :string;
    }